module.exports = __webpack_public_path__ + "static/media/banner_TeenPatti2020-half.f0c241fe.png";